<template>
  <div class="flex-container">
    <div class="info-banner">
      <template v-for="bannerItem in banner">
        <a :key="bannerItem.id" :href="bannerItem.link" v-on:click="ga(bannerItem.id)" target="blank">
          <img :src="optimizedImage(`${bannerItem.image.url}?w=600`)" loading="lazy" />
        </a>
      </template>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { optimizeImage } from "@/lib/utils/url";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    banner: Array,
  },
  methods: {
    ga(id) {
      (this as any).$ga.event("banner", "click", id, 1);
    },
    optimizedImage(url: string) {
      return optimizeImage(url);
    },
  },
});

interface Props {
  banner: object[];
}

interface Data {}

interface Computed {}

interface Methods {
  ga(id: string): void;
  optimizedImage(url: string): string;
}
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .info-banner {
    display: flex;
    flex-direction: column;
    justify-content: center;

    a {
      margin-bottom: 15px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    img {
      width: 100%;
    }
  }
}
</style>
